// const BASE_URL = (process.env.REACT_APP_GRIR_API_URL || 'https://dev-agent.savictech.com/grir/api/v1/grir').replace(/\/$/, '');

// async function handleResponse(res) {
//   if (!res.ok) {
//     let detail = `HTTP ${res.status}`;
//     try {
//       const data = await res.json();
//       if (Array.isArray(data.detail)) {
//         // FastAPI 422 validation errors — show field + message
//         detail = data.detail
//           .map((e) => `[${Array.isArray(e.loc) ? e.loc.join(' → ') : e.loc}] ${e.msg}`)
//           .join(' | ');
//       } else if (typeof data.detail === 'string') {
//         detail = data.detail;
//       } else {
//         detail = JSON.stringify(data);
//       }
//     } catch (_) {}
//     throw new Error(detail);
//   }
//   return res.json();
// }

// function buildQs(params = {}) {
//   const clean = Object.fromEntries(
//     Object.entries(params).filter(([, v]) => v !== '' && v !== undefined && v !== null)
//   );
//   const qs = new URLSearchParams(clean).toString();
//   return qs ? '?' + qs : '';
// }

// export const getDashboard = () =>
//   fetch(`${BASE_URL}/dashboard`).then(handleResponse);

// export const testSapConnection = () =>
//   fetch(`${BASE_URL}/sap/test-connection`).then(handleResponse);

// export const sapSync = (payload) =>
//   fetch(`${BASE_URL}/sap-sync`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(payload),
//   }).then(handleResponse);

// export const uploadGR = (file) => {
//   const formData = new FormData();
//   formData.append('files', file);
//   return fetch(`${BASE_URL}/upload/gr`, { method: 'POST', body: formData }).then(handleResponse);
// };

// export const uploadIR = (file) => {
//   const formData = new FormData();
//   formData.append('files', file);
//   return fetch(`${BASE_URL}/upload/ir`, { method: 'POST', body: formData }).then(handleResponse);
// };

// export const getGoodsReceipts = (params = {}) =>
//   fetch(`${BASE_URL}/goods-receipts${buildQs(params)}`).then(handleResponse);

// export const getInvoiceReceipts = (params = {}) =>
//   fetch(`${BASE_URL}/invoice-receipts${buildQs(params)}`).then(handleResponse);

// export const runReconciliation = (payload) =>
//   fetch(`${BASE_URL}/reconcile`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(payload),
//   }).then(handleResponse);

// export const getReconciliations = (params = {}) =>
//   fetch(`${BASE_URL}/reconciliations${buildQs(params)}`).then(handleResponse);

// export const getReconciliationDetail = (id) =>
//   fetch(`${BASE_URL}/reconciliations/${id}`).then(handleResponse);

// export const exportReconciliation = (id, params = {}) => {
//   const qs = new URLSearchParams({
//     format: 'excel',
//     include_matched: 'true',
//     include_unmatched: 'true',
//     ...params,
//   }).toString();
//   window.location.href = `${BASE_URL}/reconciliations/${id}/export?${qs}`;
// };

// export const getUploadHistory = (params = {}) =>
//   fetch(`${BASE_URL}/uploads${buildQs(params)}`).then(handleResponse);


const BASE_URL = (process.env.REACT_APP_GRIR_API_URL || 'https://dev-agent.savictech.com/grir/api/v1/grir').replace(/\/$/, '');

async function handleResponse(res) {
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const data = await res.json();
      if (Array.isArray(data.detail)) {
        // FastAPI 422 validation errors — show field + message
        detail = data.detail
          .map((e) => `[${Array.isArray(e.loc) ? e.loc.join(' → ') : e.loc}] ${e.msg}`)
          .join(' | ');
      } else if (typeof data.detail === 'string') {
        detail = data.detail;
      } else {
        detail = JSON.stringify(data);
      }
    } catch (_) {}
    throw new Error(detail);
  }
  return res.json();
}

function buildQs(params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== '' && v !== undefined && v !== null)
  );
  const qs = new URLSearchParams(clean).toString();
  return qs ? '?' + qs : '';
}

export const getDashboard = () =>
  fetch(`${BASE_URL}/dashboard`).then(handleResponse);

export const testSapConnection = () =>
  fetch(`${BASE_URL}/sap/test-connection`).then(handleResponse);

export const sapSync = (payload) =>
  fetch(`${BASE_URL}/sap-sync`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then(handleResponse);

export const uploadGR = (files) => {
  const formData = new FormData();
  (Array.isArray(files) ? files : [files]).forEach((f) => formData.append('files', f));
  return fetch(`${BASE_URL}/upload/gr`, { method: 'POST', body: formData }).then(handleResponse);
};

export const uploadIR = (files) => {
  const formData = new FormData();
  (Array.isArray(files) ? files : [files]).forEach((f) => formData.append('files', f));
  return fetch(`${BASE_URL}/upload/ir`, { method: 'POST', body: formData }).then(handleResponse);
};

export const getGoodsReceipts = (params = {}) =>
  fetch(`${BASE_URL}/goods-receipts${buildQs(params)}`).then(handleResponse);

export const getInvoiceReceipts = (params = {}) =>
  fetch(`${BASE_URL}/invoice-receipts${buildQs(params)}`).then(handleResponse);

export const runReconciliation = (payload) =>
  fetch(`${BASE_URL}/reconcile`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then(handleResponse);

export const getReconciliations = (params = {}) =>
  fetch(`${BASE_URL}/reconciliations${buildQs(params)}`).then(handleResponse);

export const getReconciliationDetail = (id) =>
  fetch(`${BASE_URL}/reconciliations/${id}`).then(handleResponse);

export const exportReconciliation = (id, params = {}) => {
  const qs = new URLSearchParams({
    format: 'excel',
    include_matched: 'true',
    include_unmatched: 'true',
    ...params,
  }).toString();
  window.location.href = `${BASE_URL}/reconciliations/${id}/export?${qs}`;
};

export const getUploadHistory = (params = {}) =>
  fetch(`${BASE_URL}/uploads${buildQs(params)}`).then(handleResponse);
